import { render, staticRenderFns } from "./modalEliminarProducto.vue?vue&type=template&id=52ef11b5"
import script from "./modalEliminarProducto.vue?vue&type=script&lang=js"
export * from "./modalEliminarProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports